import React, { useState } from "react";
import { C, NAV_LINKS } from "../constants";
import { useScrollY } from "../hooks";
import { Btn } from "./UI";

export default function Navbar({ page, setPage }) {
  const scrollY  = useScrollY();
  const [mOpen, setMOpen] = useState(false);
  const scrolled = scrollY > 40;

  const go = (p) => {
    setPage(p);
    setMOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* ── DESKTOP / MOBILE NAV BAR ── */}
      <nav style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 9000,
        height: scrolled ? 66 : 84,
        background: "rgba(255,255,255,0.97)",
        boxShadow: scrolled ? "0 1px 28px rgba(0,0,0,0.09)" : "0 1px 0 rgba(0,0,0,0.07)",
        backdropFilter: "blur(18px)",
        transition: "height 0.3s ease, box-shadow 0.3s ease",
        display: "flex", alignItems: "center",
        padding: "0 clamp(20px, 6vw, 100px)",
      }}>
        {/* Logo */}
        <button onClick={() => go("home")} style={{ background: "none", border: "none", cursor: "pointer", marginRight: "auto", textAlign: "left" }}>
          <div style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 900, fontSize: 20, color: C.black, letterSpacing: 1 }}>
            THARAGAI
          </div>
          <div style={{ fontFamily: "'Poppins', sans-serif", fontSize: 8, color: C.muted, letterSpacing: 5, marginTop: 1 }}>
            PRODUCTIONS
          </div>
        </button>

        {/* Desktop links */}
        <ul className="tp-desktop-nav" style={{ display: "flex", gap: 36, listStyle: "none", alignItems: "center" }}>
          {NAV_LINKS.map((l) => (
            <li key={l.page}>
              <button
                onClick={() => go(l.page)}
                style={{
                  background: "none", border: "none", cursor: "pointer",
                  fontFamily: "'Montserrat', sans-serif", fontWeight: 700,
                  fontSize: 11, letterSpacing: 2, textTransform: "uppercase",
                  color: page === l.page ? C.accent : C.charcoal,
                  borderBottom: `2px solid ${page === l.page ? C.accent : "transparent"}`,
                  paddingBottom: 3, transition: "all 0.22s",
                }}
              >
                {l.label}
              </button>
            </li>
          ))}
          <li>
            <Btn variant="solid" onClick={() => go("contact")} style={{ padding: "9px 22px", fontSize: 11 }}>
              Start Project
            </Btn>
          </li>
        </ul>

        {/* Hamburger */}
        <button
          className="tp-mobile-btn"
          onClick={() => setMOpen(!mOpen)}
          style={{ background: "none", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", gap: 5, padding: 8 }}
          aria-label="Toggle menu"
        >
          {[0, 1, 2].map((i) => (
            <span key={i} style={{
              width: i === 1 ? (mOpen ? 0 : 16) : 24,
              height: 2, background: C.black, display: "block",
              transition: "all 0.3s",
              transform: mOpen
                ? (i === 0 ? "rotate(45deg) translateY(7px)" : i === 2 ? "rotate(-45deg) translateY(-7px)" : "none")
                : "none",
              opacity: i === 1 && mOpen ? 0 : 1,
            }} />
          ))}
        </button>
      </nav>

      {/* ── MOBILE FULLSCREEN MENU ── */}
      <div style={{
        position: "fixed", inset: 0, zIndex: 8999,
        background: C.white,
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 4,
        opacity: mOpen ? 1 : 0, visibility: mOpen ? "visible" : "hidden",
        transition: "all 0.35s ease",
      }}>
        {NAV_LINKS.map((l, i) => (
          <button
            key={l.page}
            onClick={() => go(l.page)}
            style={{
              background: "none", border: "none", cursor: "pointer",
              fontFamily: "'Montserrat', sans-serif", fontWeight: 900,
              fontSize: "clamp(28px, 7vw, 46px)",
              color: page === l.page ? C.accent : C.black,
              letterSpacing: 0.5, padding: "10px 20px",
              transform: mOpen ? "translateY(0)" : "translateY(18px)",
              opacity: mOpen ? 1 : 0,
              transition: `all 0.38s ease ${i * 0.06}s`,
            }}
          >
            {l.label}
          </button>
        ))}
      </div>
    </>
  );
}
